import { ApiErrorBody } from '@shared/types/errors';
import { HttpError } from '@shared/utils/HttpError';

export function matchesErrorCode(code: string | null | undefined, expected: string): boolean {
  return code === expected;
}

export function parseApiErrorText(text: string): ApiErrorBody {
  const trimmed = text.trim();
  if (!trimmed) {
    return {};
  }

  try {
    return toApiErrorBody(JSON.parse(trimmed));
  } catch {
    return { message: trimmed };
  }
}

export async function parseApiErrorBody(response: Response): Promise<ApiErrorBody> {
  const text = await response.text().catch(() => '');
  return parseApiErrorText(text);
}

export async function httpErrorFromResponse(response: Response, fallbackCode?: string): Promise<HttpError> {
  const body = await parseApiErrorBody(response);
  const code = body.code ?? fallbackCode;

  return new HttpError(response.status, body.message ?? code, {
    code,
    detail: body.message,
  });
}

export async function ensureOk(response: Response): Promise<void> {
  if (response.ok) {
    return;
  }

  throw await httpErrorFromResponse(response);
}

function toApiErrorBody(parsed: unknown): ApiErrorBody {
  if (typeof parsed !== 'object' || parsed === null) {
    return {};
  }

  const { code, message } = parsed as { code?: unknown; message?: unknown };

  return {
    code: typeof code === 'string' && code.length > 0 ? code : undefined,
    message: typeof message === 'string' && message.length > 0 ? message : undefined,
  };
}